<div id="hits"></div>
<div id="propertiesHits"></div>
<div id="bookingAccountsHits"></div>
<div class="relative flex flex-col w-full h-full">

    <!-- Dismiss button -->
    <div class="absolute top-0 right-0 pt-4 pr-4">
        <button
            [matDialogClose]="undefined"
            mat-icon-button>
            <mat-icon
                [svgIcon]="'mat_outline:close'"
                class="text-secondary"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex flex-col w-full p-8 pb-6 sm:pb-8">
        <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start">

            <!-- Icon -->
            <div
                class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600">
                <mat-icon
                    [svgIcon]="'mat_outline:add_circle_outline'"
                    class="text-current"></mat-icon>
            </div>

            <div
                class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left">

                <!-- Title -->
                <div class="text-xl leading-6 font-medium">
                    Neue Regel erstellen
                </div>

                <!-- Message -->
                <div class="text-secondary">
                    Definieren Sie Bedingungen und Zuordnungen für automatische Buchungsvorschläge.
                </div>

            </div>

        </div>

        <div class="w-full my-4">
            <mat-divider></mat-divider>
        </div>

        <!-- Stepper to create the rule -->
        <div>
            <mat-vertical-stepper #stepper [linear]="true">

                <!-- Step 0: Regelname eingeben -->
                <mat-step [stepControl]="ruleFormGroup.get('ruleName')">
                    <form [formGroup]="ruleFormGroup">
                        <ng-template matStepLabel>
                            @if (this.ruleFormGroup.get('name')?.value && stepper.selectedIndex !== 0) {
                                <span @zoomIn @zoomOut>{{ this.ruleFormGroup.get('name')?.value }}</span>
                            } @else {
                                <span @zoomIn @zoomOut>Regel benennen</span>
                            }
                        </ng-template>
                        <div class="flex flex-col space-y-4 w-full">
                            <mat-form-field appearance="fill" class="w-full mb-4">
                                <mat-label>Regelname</mat-label>
                                <input
                                    matInput
                                    formControlName="name"
                                    maxlength="80"
                                    placeholder="z.B. Mieteingang Müller GmbH">
                                <mat-hint align="end">
                                    {{ ruleFormGroup.get('name')?.value?.length || 0 }}/80
                                </mat-hint>
                                <mat-error *ngIf="ruleFormGroup.get('name')?.hasError('required')">
                                    Der Regelname ist erforderlich.
                                </mat-error>
                                <mat-error *ngIf="ruleFormGroup.get('name')?.hasError('maxlength')">
                                    Maximal 80 Zeichen erlaubt.
                                </mat-error>
                            </mat-form-field>
                            <div class="w-full">
                                <button [disabled]="ruleFormGroup.get('name')?.invalid"
                                        color="primary" mat-raised-button matStepperNext>Weiter
                                </button>
                            </div>
                        </div>
                    </form>
                </mat-step>

                <!-- 1. Bankaccounts-->
                <mat-step [optional]="true" [stepControl]="ruleFormGroup.get('bankAccountScope')">
                    <form [formGroup]="ruleFormGroup">
                        <ng-template matStepLabel>Geltungsbereich der Bankkonten festlegen</ng-template>

                        <div class="m-4">
                            <div class="flex justify-between">
                                <div class="flex flex-col">
                                    <div class="text-secondary text-md mt-1">
                                        Wählen Sie, ob diese Regel für alle Bankkonten oder nur für bestimmte gilt.
                                    </div>
                                </div>
                            </div>
                            <!--                            <hr class="my-2">-->
                            <div class="flex flex-wrap text-md justify-center my-4">
                                <div
                                    class="flex items-center p-0.5 rounded-full overflow-hidden bg-gray-200 dark:bg-gray-700">
                                    <button
                                        (click)="this.ruleFormGroup.get('forAllBankAccounts')?.patchValue(true)"
                                        [ngClass]="{'bg-card pointer-events-none shadow': this.ruleFormGroup.get('forAllBankAccounts')?.value,
                                        'bg-transparent': !this.ruleFormGroup.get('forAllBankAccounts')?.value}"
                                        class="px-6"
                                        disableRipple
                                        mat-flat-button>
                                        Alle Bankkonten
                                    </button>
                                    <button
                                        (click)="this.ruleFormGroup.get('forAllBankAccounts')?.patchValue(false)"
                                        [ngClass]="{'bg-card pointer-events-none shadow': !this.ruleFormGroup.get('forAllBankAccounts')?.value,
                                        'bg-transparent': this.ruleFormGroup.get('forAllBankAccounts')?.value}"
                                        class="px-6"
                                        disableRipple
                                        mat-flat-button>
                                        Benutzerdefiniert
                                        <!--                                        Nur bestimmte Bankkonten-->
                                    </button>
                                </div>
                            </div>
                            <ng-container *ngIf="!this.ruleFormGroup.get('forAllBankAccounts')?.value">
                                <hr @slideInLeft @slideOutRight class="border-b my-6">
                                <div @slideInLeft @slideOutRight class="mt-3 -mx-3">
                                    <div class="mx-6 my-2">
                                        <div class="flex flex-col items-center w-full">

                                            @if (this.selectedBankAccountsFA?.length < this.maxBankAccounts) {
                                                <div class="w-full" @slideInLeft @slideOutRight>
                                                    <app-algolia-autocomplete-new

                                                        (onInputFocused)="startSearch('bankAccounts')"
                                                        (onQuerySuggestionClick)="this.onQueryBankAccountsSuggestionClick($event)"
                                                        (onRefineQuery)="refineQuery(this.searchBankAccounts,$event)"
                                                        [hits]="hitsBankAccounts"
                                                        class="flex truncate"
                                                        formFieldClass="w-full"
                                                        label="Bankkonto suchen"
                                                        matOptionStyles="height: 70px; line-height: 10px;"
                                                        placeholder="Suche...">
                                                        <ng-template let-option='option'>
                                                            <div [matTooltip]="option?.notes"
                                                                 class="flex flex-row space-x-2 items-center truncate">
                                                                <div [matTooltip]="option?.bank"
                                                                     class="flex w-10 h-10">
                                                                    <img [src]="option?.img"
                                                                         class="object-contain">
                                                                </div>
                                                                <div class="flex flex-col truncate">
                                                                    <div class="leading-2 truncate font-semibold">
                                                                    <span
                                                                        [innerHTML]="option?._highlightResult?.bank?.value"
                                                                        class="truncate text-sm"></span>
                                                                    </div>
                                                                    <span
                                                                        [innerHTML]="option?._highlightResult?.accountHolder?.value"
                                                                        class="leading-normal text-xs"></span>
                                                                    <!--                                <div>-->
                                                                    <span
                                                                        [innerHTML]="option?._highlightResult?.IBAN?.value"
                                                                        class="truncate text-xs font-semibold"></span>
                                                                    <!--                                </div>-->
                                                                </div>
                                                            </div>
                                                        </ng-template>
                                                    </app-algolia-autocomplete-new>
                                                </div>
                                            } @else {
                                                <div class="w-full" @slideInLeft @slideOutRight>
                                                    <!-- Alert, wenn das Limit erreicht ist -->
                                                    <fuse-alert
                                                        *ngIf="this.selectedBankAccountsFA?.length >= this.maxBankAccounts"
                                                        type="warning"
                                                        class="my-4"
                                                    >
                                                        Sie können nicht mehr als <span
                                                        class="font-extrabold">{{ this.maxBankAccounts }}
                                                        Bankkonten</span>
                                                        auswählen.
                                                    </fuse-alert>
                                                </div>
                                            }


                                            <div class="w-full mt-1" formArrayName="selectedBankAccounts">
                                                <mat-chip-listbox #chipGrid>
                                                    <mat-chip-option
                                                        *ngFor="let bankAccountControl of selectedBankAccountsFormArray.controls; let i = index; trackBy: trackByFn"
                                                        @zoomIn
                                                        @zoomOut
                                                        [matTooltip]="'IBAN: ' + bankAccountControl?.value?.IBAN + ' - ' + bankAccountControl?.value?.accountHolder"
                                                        color="primary">
                                                        <img
                                                            [src]="bankAccountControl?.value?.img || 'assets/icons/fallbackImage/image-square-warn.svg'"
                                                            class="drop-shadow-xl"
                                                            loading="lazy"
                                                            matChipAvatar
                                                            src-fallback="assets/icons/fallbackImage/image-square-warn.svg"/>
                                                        <span class="flex truncate max-w-40">
                                                            {{ bankAccountControl?.value?.bank }} {{ bankAccountControl?.value?.IBAN }}
                                                        </span>
                                                        <button
                                                            (click)="removeBankAccount(bankAccountControl?.value?.id)"
                                                            matChipRemove
                                                            matTooltip="Bankkonto entfernen">
                                                            <mat-icon color="accent">cancel</mat-icon>
                                                        </button>
                                                    </mat-chip-option>
                                                </mat-chip-listbox>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </ng-container>
                            <fuse-alert class="ml-4 flex-1 drop-shadow-xl"
                                        *ngIf="(this.ruleFormGroup.get('forAllBankAccounts').value === false) && (this.selectedBankAccountsFA?.length === 0)"
                                        [type]="'primary'"
                                        [appearance]="'soft'"
                                        [dismissible]="true"
                                        @slideOutBottom>
                                <mat-icon class="icon-size-5"
                                          fuseAlertIcon
                                          [svgIcon]="'mat_outline:info'"></mat-icon>
                                <span>Wenn Sie bestimmte Konten auswählen, wird die Regel nur auf diese angewendet.
                                      Wenn Sie kein Konto auswählen, gilt die Regel automatisch für alle Ihre Bankkonten.</span>
                            </fuse-alert>
                        </div>

                        <!-- Navigation Buttons -->
                        <div class="mt-8">
                            <button color="primary" mat-raised-button matStepperNext>Weiter</button>
                        </div>
                    </form>
                </mat-step>

                <!-- 2. IBAN -->
                <mat-step [stepControl]="this.ruleFormGroup?.get('transactionIban')">
                    <form [formGroup]="this.ruleFormGroup">
                        <ng-template matStepLabel>IBAN eingeben</ng-template>

                        <div class="flex flex-col space-y-4 w-full">

                            <mat-slide-toggle
                                color="primary"
                                formControlName="requireTransactionIban">
                                IBAN als Pflichtkriterium verwenden
                            </mat-slide-toggle>

                            <ng-container *ngIf="ruleFormGroup.get('requireTransactionIban')?.value">
                                <mat-form-field @zoomIn @zoomOut appearance="fill" class="w-full mb-4">
                                    <mat-label>IBAN</mat-label>
                                    <input
                                        formControlName="transactionIban"
                                        matInput
                                        placeholder="z.B. DE12345678901234567890">

                                    <mat-hint *ngIf="ruleFormGroup.get('requireTransactionIban')?.value">
                                        Wenn aktiviert, wird die Regel nur angewendet, wenn die Transaktion genau diese
                                        IBAN enthält.
                                    </mat-hint>

                                    <mat-hint *ngIf="!ruleFormGroup.get('requireTransactionIban')?.value">
                                        Optional: Wenn keine IBAN hinterlegt ist, wird die Regel nur anhand der
                                        definierten Bedingungen
                                        wie Verwendungszweck, Name, Betrag oder Datum geprüft.
                                    </mat-hint>

                                    <mat-error *ngIf="this.ruleFormGroup.get('transactionIban')?.hasError('required')">
                                        Die IBAN ist erforderlich.
                                    </mat-error>

                                    <mat-error *ngIf="this.ruleFormGroup.get('transactionIban')?.hasError('pattern')">
                                        Bitte geben Sie eine gültige IBAN ein.
                                    </mat-error>
                                </mat-form-field>
                            </ng-container>

                            <fuse-alert @zoomIn @zoomOut
                                        [type]="'primary'"
                                        [appearance]="'soft'"
                                        *ngIf="!ruleFormGroup.get('requireTransactionIban')?.value">
                                Ohne Pflicht-IBAN kann die Regel breiter greifen. In diesem Fall sollten die Bedingungen
                                eindeutig definiert sein.
                            </fuse-alert>

                            <div class="w-full">
                                <button mat-button matStepperPrevious>Zurück</button>
                                <button
                                    [disabled]="this.ruleFormGroup?.get('transactionIban')?.invalid"
                                    color="primary"
                                    mat-raised-button
                                    matStepperNext>
                                    Weiter
                                </button>
                            </div>
                        </div>
                    </form>
                </mat-step>

                <!-- Step.3: Bedingungen definieren -->
                <mat-step [stepControl]="this.conditions">
                    <form [formGroup]="this.ruleFormGroup">
                        <!--                    <form>-->
                        <ng-template matStepLabel>Bedingungen definieren</ng-template>
                        <p>Bitte geben Sie die Bedingungen für die Regel ein, z.B Betrag, Datum,
                            Verwendungszweck und Name.</p>

                        <div class="mt-4 drop-shadow-xl" formArrayName="conditions">
                            <div
                                *ngFor="let condition of conditions.controls; let i = index; trackBy: trackByFn; let first = first; let last = last;"
                                [formGroupName]="i"
                                class="mb-3 p-3 border rounded drop-shadow-xl">

                                <!-- Auswahl des zu prüfenden Feldes -->
                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label>Bedingungstyp</mat-label>
                                    <mat-select (selectionChange)="onFieldChanged($event, i)" formControlName="field">

                                    <span
                                        [matTooltip]="isConditionFieldDisabled('reference', i) ? 'Diese Bedingung kann nur einmal ausgewählt werden.' : null">
                                        <mat-option
                                            value="reference"
                                            [disabled]="isConditionFieldDisabled('reference', i)">
                                            <mat-icon class="mr-2">description</mat-icon>
                                            Verwendungszweck
                                        </mat-option>
                                    </span>

                                        <span
                                            [matTooltip]="isConditionFieldDisabled('name', i) ? 'Diese Bedingung kann nur einmal ausgewählt werden.' : null">
                                        <mat-option
                                            value="name"
                                            [disabled]="isConditionFieldDisabled('name', i)">
                                            <mat-icon class="mr-2">person</mat-icon>
                                            Name
                                        </mat-option>
                                    </span>

                                        <span
                                            [matTooltip]="isConditionFieldDisabled('amount', i) ? 'Diese Bedingung kann nur einmal ausgewählt werden.' : null">
                                        <mat-option
                                            value="amount"
                                            [disabled]="isConditionFieldDisabled('amount', i)">
                                            <mat-icon class="mr-2">attach_money</mat-icon>
                                            Betrag
                                        </mat-option>
                                    </span>

                                        <span
                                            [matTooltip]="isConditionFieldDisabled('date', i) ? 'Diese Bedingung kann nur einmal ausgewählt werden.' : null">
                                        <mat-option
                                            value="date"
                                            [disabled]="isConditionFieldDisabled('date', i)">
                                            <mat-icon class="mr-2">date_range</mat-icon>
                                            Datum
                                        </mat-option>
                                    </span>
                                    </mat-select>
                                </mat-form-field>

                                <!-- Auswahl des Vergleichsoperators -->
                                <ng-container *ngIf="condition.get('field')?.value as field">
                                    <mat-form-field *ngIf="field === 'reference'"
                                                    @zoomIn @zoomOut
                                                    appearance="fill" class="w-full">
                                        <mat-label>Operator</mat-label>
                                        <mat-select formControlName="operator">
                                            <mat-option @zoomIn @zoomOut
                                                        value="EQUAL">Gleich
                                            </mat-option>
                                            <mat-option @zoomIn @zoomOut
                                                        value="CONTAINS">Enthält
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field *ngIf="field === 'name'"
                                                    @zoomIn @zoomOut
                                                    appearance="fill" class="w-full">
                                        <mat-label>Operator</mat-label>
                                        <mat-select formControlName="operator">
                                            <mat-option @zoomIn @zoomOut
                                                        value="EQUAL">Gleich
                                            </mat-option>
                                            <mat-option @zoomIn @zoomOut
                                                        value="CONTAINS">Enthält
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field *ngIf="field === 'amount'"
                                                    @zoomIn @zoomOut
                                                    appearance="fill" class="w-full">
                                        <mat-label>Operator</mat-label>
                                        <mat-select formControlName="operator">
                                            <mat-option @zoomIn @zoomOut
                                                        value="EQUAL">Gleich
                                            </mat-option>
                                            <mat-option @zoomIn @zoomOut
                                                        value="LESS_THAN">Kleiner als
                                            </mat-option>
                                            <mat-option @zoomIn @zoomOut
                                                        value="GREATER_THAN">Größer als
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field *ngIf="field === 'date'"
                                                    @zoomIn @zoomOut
                                                    appearance="fill" class="w-full">
                                        <mat-label>Operator</mat-label>
                                        <mat-select formControlName="operator">
                                            <!--                                            <mat-option @zoomIn @zoomOut-->
                                            <!--                                                        value="EQUAL">Gleich-->
                                            <!--                                            </mat-option>-->
                                            <mat-option @zoomIn @zoomOut
                                                        value="LESS_THAN">Kleiner als
                                            </mat-option>
                                            <mat-option @zoomIn @zoomOut
                                                        value="GREATER_THAN">Größer als
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </ng-container>


                                <ng-container *ngIf="!!condition.get('operator')?.value">
                                    <!-- Eingabe des Vergleichswertes -->
                                    @switch (condition.get('field')?.value) {
                                        @case ('amount') {
                                            <mat-form-field appearance="fill" class="w-full" @zoomIn @zoomOut>
                                                <mat-label>Wert</mat-label>
                                                <input matInput
                                                       [options]="{ prefix: '€', thousands: '.', decimal: ',',align: 'left'}"
                                                       currencyMask formControlName="value"
                                                       placeholder="Wert eingeben in Euro">
                                            </mat-form-field>
                                        }
                                        @case ('reference') {
                                            <mat-form-field appearance="fill" class="w-full" @zoomIn @zoomOut>
                                                <mat-label>Wert</mat-label>
                                                <input matInput
                                                       formControlName="value"
                                                       placeholder="Wert eingeben"
                                                       maxlength="100">
                                                <!-- Mat-Hint: Zeigt die aktuelle Zeichenanzahl -->
                                                <mat-hint align="end">
                                                    {{ condition.get('value')?.value?.length || 0 }}/100
                                                </mat-hint>
                                                <!-- Mat-Error: Wird angezeigt, wenn der Validator ausgelöst wird -->
                                                <mat-error *ngIf="condition.get('value')?.hasError('maxlength')">
                                                    Maximale Länge von 100 Zeichen überschritten.
                                                </mat-error>
                                            </mat-form-field>
                                        }
                                        @case ('name') {
                                            <mat-form-field appearance="fill" class="w-full" @zoomIn @zoomOut>
                                                <mat-label>Wert</mat-label>
                                                <input matInput
                                                       formControlName="value"
                                                       placeholder="Wert eingeben"
                                                       maxlength="100">
                                                <mat-hint align="end">
                                                    {{ condition.get('value')?.value?.length || 0 }}/80
                                                </mat-hint>
                                                <mat-error *ngIf="condition.get('value')?.hasError('maxlength')">
                                                    Maximale Länge von 100 Zeichen überschritten.
                                                </mat-error>
                                            </mat-form-field>
                                        }
                                        @case ('date') {
                                            <mat-form-field appearance="fill" class="w-full" @zoomIn @zoomOut>
                                                <mat-label>Wert</mat-label>
                                                <input matInput formControlName="value" placeholder="tt.mm.jjjj"
                                                       [matDatepicker]="picker">
                                                <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </mat-form-field>
                                        }
                                    }
                                </ng-container>
                                <!-- Button zum Entfernen der Bedingung -->
                                <button *ngIf="!first"
                                        @zoomIn @zoomOut
                                        (click)="removeCondition(i)" aria-label="Bedingung entfernen" color="warn"
                                        mat-icon-button matTooltip="Bedingung entfernen">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>

                            <!-- Button zum Hinzufügen einer neuen Bedingung -->
                            <button (click)="addCondition()" class="my-4" color="primary" mat-raised-button>
                                <mat-icon>add_circle</mat-icon>
                                <span class="ml-2">Bedingung hinzufügen</span>
                            </button>
                        </div>


                        <div class="mt-6">
                            <button mat-button matStepperPrevious>Zurück</button>
                            <!--                                <button mat-button matStepperNext [disabled]="!conditionFormGroup.valid">Weiter</button>-->
                            <button [disabled]="this.conditions.invalid ||  this.conditions.length === 0"
                                    color="primary" mat-raised-button
                                    matStepperNext>Weiter
                            </button>
                        </div>
                    </form>
                </mat-step>

                <!-- Step.4: Zuordnungen auswählen -->
                <mat-step [stepControl]="this.ruleFormGroup.get('targetType')">
                    <form [formGroup]="this.ruleFormGroup">
                        <ng-template matStepLabel>Zuordnungstyp auswählen</ng-template>
                        <p>Wählen Sie, ob diese Regel eine Ausgabe/Gutschrift oder eine Sollstellung betrifft.</p>

                        <div class="my-6 w-full">
                            <mat-radio-group color="primary" formControlName="targetType">
                                <mat-radio-button class="mr-4" value="expense">Ausgabe/Gutschrift</mat-radio-button>
                                <mat-radio-button value="booking">Sollstellung</mat-radio-button>
                            </mat-radio-group>
                        </div>

                        <div class="mt-4">
                            <button mat-button matStepperPrevious>Zurück</button>
                            <button [disabled]="this.ruleFormGroup.get('targetType').invalid" color="primary"
                                    mat-raised-button
                                    matStepperNext>
                                Weiter
                            </button>
                        </div>
                    </form>
                </mat-step>

                <!-- Step.5: Zuordnungen auswählen -->
                @if (this.ruleFormGroup.get('targetType')?.value === 'expense') {
                    <mat-step [stepControl]="this.expensesAssignments">
                        <form [formGroup]="this.ruleFormGroup">
                            <ng-template matStepLabel>Zuordnung vervollständigen</ng-template>
                            <p>Bitte wählen Sie die entsprechenden Zuordnungen aus.</p>

                            <div formArrayName="expensesAssignments" class="mt-4 drop-shadow-xl">
                                <div
                                    *ngFor="let assignement of expensesAssignments.controls; let i = index; trackBy: trackByFn; let first = first; let last = last;"
                                    [formGroupName]="i"
                                    class="mb-3 p-3 border rounded drop-shadow-xl">

                                    <div *ngIf="!first" class="flex justify-between items-center">
                                        <h4 class="font-semibold">Ziel {{ i + 1 }}</h4>
                                        <button mat-icon-button color="warn" (click)="removeExpenseAssignment(i)"
                                                matTooltip="Ziel entfernen">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>

                                    <div class="w-full my-4">
                                        <mat-vertical-stepper #stepper [linear]="true">
                                            <!-- select property -->
                                            <mat-step [stepControl]="assignement.get('property')">
                                                <ng-template
                                                    [matTooltip]="assignement.get('property')?.invalid ? 'Wählen Sie die Immobilie aus' : ''"
                                                    matStepLabel>
                                                    <ng-container *ngIf="stepper.selectedIndex !== 0">
                                                        <ng-container
                                                            *ngIf="assignement.get('property')?.value as property">
                                                            <span>H{{ property?.h_id }} {{ property?.address | formatAddress }}</span>
                                                        </ng-container>
                                                    </ng-container>
                                                    <span
                                                        *ngIf="assignement.get('property')?.invalid || stepper.selectedIndex === 0">Wählen Sie die Immobilie aus</span>
                                                </ng-template>
                                                <div *ngIf="!this.assignement.get('property')?.value"
                                                     @zoomIn @zoomOut
                                                     class="flex flex-col space-y-2 w-full">
                                                    <app-algolia-autocomplete-new
                                                        (onQuerySuggestionClick)="this.onQueryPropertySuggestionClick($event,i)"
                                                        (onRefineQuery)="refineQuery(this.searchProperties,$event)"
                                                        (onInputFocused)="startSearch('properties')"
                                                        [hits]="this.hitsProperties"
                                                        formFieldClass="w-full"
                                                        label="Suchen Sie nach der Adresse der Immobilie"
                                                        matOptionStyles="height: 70px; line-height: 20px;"
                                                        placeholder="Suche...">
                                                        <ng-template let-option='option'>
                                                            <div class="flex flex-col">
                                                                    <span
                                                                        [innerHTML]="option?._highlightResult?.h_id_text?.value && option?._highlightResult?.h_id_text?.matchLevel === 'full' ? option?._highlightResult?.h_id_text?.value : 'H' + option?._highlightResult?.h_id?.value + ' ' + option?._highlightResult?.address?.streetName?.value + ' ' + option?._highlightResult?.address?.streetNumber?.value"
                                                                        matLine></span>
                                                                <span
                                                                    [innerHTML]="option?._highlightResult?.address?.postalCode?.value + ' ' + option?._highlightResult?.address?.locality?.long?.value"
                                                                    class="text-xs" matLine></span>
                                                                <mat-divider class="mt-2"></mat-divider>
                                                            </div>
                                                        </ng-template>
                                                    </app-algolia-autocomplete-new>
                                                </div>
                                                <div
                                                    *ngIf="assignement.get('property')?.value as property"
                                                    @zoomIn @zoomOut
                                                    class="w-full">
                                                    <!-- Card #43 -->
                                                    <fuse-card
                                                        class="flex items-center justify-between max-w-80 w-full p-6 filter-info drop-shadow-xl mb-2">
                                                        <div class="flex flex-col">
                                                            <div class="text-2xl font-semibold leading-tight">
                                                                Immobilie <span
                                                                class="font-extrabold text-primary">H{{ property?.h_id }}</span>
                                                            </div>
                                                            <div
                                                                class="text-md leading-tight text-primary">{{ property?.address | formatAddress }}
                                                            </div>
                                                            <!--								<div class="text-md text-secondary mt-2">h.brian@company.com</div>-->
                                                        </div>
                                                        <button
                                                            (click)="assignement.get('property').patchValue(null)"
                                                            color="warn"
                                                            mat-mini-fab
                                                            matTooltip="Zurücksetzen">
                                                            <mat-icon
                                                                [svgIcon]="'mat_outline:close'"
                                                                class="icon-size-5 text-current"></mat-icon>
                                                        </button>
                                                        <!--							<img-->
                                                        <!--									class="w-16 h-16 ml-6 rounded-full"-->
                                                        <!--									src="assets/images/avatars/male-04.jpg"-->
                                                        <!--									alt="Card cover image">-->
                                                    </fuse-card>
                                                </div>
                                                <div *ngIf="this.assignement.get('property')?.invalid" @zoomIn
                                                     @zoomOut
                                                     class="w-full mt-4">
                                                    <!-- Warn -->
                                                    <fuse-alert [type]="'warn'">
                                                        <span fuseAlertTitle>Keine Immobilie ausgewählt</span>
                                                        Bitte wählen Sie eine Immobilie aus der Liste aus, bevor Sie
                                                        fortfahren.
                                                    </fuse-alert>
                                                </div>
                                                <div class="mt-4">
                                                    <button color="primary"
                                                            [disabled]="assignement.get('property')?.invalid"
                                                            mat-raised-button
                                                            matStepperNext>
                                                        Weiter
                                                    </button>
                                                </div>
                                            </mat-step>
                                            <mat-step [stepControl]="assignement.get('nahausBookingsAccount')">
                                                <ng-template
                                                    [matTooltip]="'Buchungskonto auswählen'"
                                                    matStepLabel>
                                                    <ng-container *ngIf="stepper.selectedIndex !== 1">
                                                        <ng-container
                                                            *ngIf="assignement.get('nahausBookingsAccount')?.value as bookingAccount">
                                                            <div class="truncate max-w-40">[{{ bookingAccount?.refID }}]&nbsp;{{ bookingAccount?.label }}</div>
                                                        </ng-container>
                                                    </ng-container>
                                                    <span
                                                        *ngIf="assignement.get('nahausBookingsAccount')?.invalid || stepper.selectedIndex === 1">
                                                        Buchungskonto auswählen</span>
                                                </ng-template>
                                                <app-algolia-autocomplete-new placeholder="Search for products..."
                                                                              (onQuerySuggestionClick)="this.onQueryBookingAccountSuggestionClick($event,i)"
                                                                              (onRefineQuery)="refineQuery(searchBookingAccounts,$event)"
                                                                              (onInputFocused)="startSearch('bookingAccounts')"
                                                                              [hits]="this.hitsBookingsAccounts"
                                                                              formFieldClass="w-full"
                                                                              [placeholder]="'Buchungskonten suchen...'">
                                                    <ng-template let-option="option">
                                                        <div class="flex flex-row space-x-2 items-center">
                                                            <div class="flex flex-row">
                                                                <div *ngIf="option.refID"
                                                                     class="px-2 bg-primary text-on-primary rounded">
                                                                <span
                                                                    class="text-truncate font-weight-600"
                                                                    [innerHTML]="option?._highlightResult?.refID?.value"
                                                                    matLine></span>
                                                                </div>
                                                            </div>
                                                            <span
                                                                [innerHTML]="option?._highlightResult?.label?.value"
                                                                matLine></span>
                                                        </div>
                                                    </ng-template>
                                                </app-algolia-autocomplete-new>
                                                <mat-chip
                                                    *ngIf="assignement.get('nahausBookingsAccount')?.value as bookingAccount"
                                                    @zoomIn @zoomOut
                                                    (removed)="removeBookingAccount(i)"
                                                    [matTooltip]="'[' + bookingAccount?.refID + '] ' + bookingAccount?.label"
                                                    color="primary">
                                                    <div class="truncate max-w-40">[{{ bookingAccount?.refID }}
                                                        ] {{ bookingAccount?.label }}
                                                    </div>
                                                    <button matChipRemove>
                                                        <mat-icon>cancel</mat-icon>
                                                    </button>
                                                </mat-chip>
                                                <div class="mt-4">
                                                    <button color="primary"
                                                            [disabled]="assignement.get('nahausBookingsAccount')?.invalid"
                                                            mat-raised-button
                                                            matStepperNext>
                                                        Weiter
                                                    </button>
                                                </div>
                                            </mat-step>
                                            <mat-step>
                                                <ng-template
                                                    matStepLabel>
                                                    <span>MWST-Optionen festlegen</span>
                                                </ng-template>
                                                <div class="flex flex-col space-y-2">
                                                    <!-- Checkbox für includesVAT -->
                                                    <mat-checkbox
                                                        class="drop-shadow-2xl"
                                                        color="primary"
                                                        [formControlName]="'includesVAT'"
                                                        (change)="onVATChange(i, $event)">
                                                        Beinhaltet MWST
                                                    </mat-checkbox>
                                                    <div *ngIf="expensesAssignments.at(i).get('includesVAT')?.value"
                                                         class="w-full">
                                                        <mat-form-field
                                                            class="fuse-mat-emphasized-affix w-full drop-shadow-2xl"
                                                            subscriptSizing="dynamic">
                                                            <!-- Prefix -->
                                                            <div class="flex flex-col space-y-3" matPrefix>
                                                                <span class="text-sm">MWST-</span>
                                                                <span class="text-sm">Satz</span>
                                                            </div>
                                                            <!-- Input field -->
                                                            <input formControlName="vatRate" matInput
                                                                   placeholder="MWST-Satz in %" type="number">

                                                            <!-- Suffix -->
                                                            <span matSuffix class="text-secondary">%</span>

                                                            <!-- Error message -->
                                                            <mat-error>Ungültiger MWST-Satz</mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </mat-step>
                                        </mat-vertical-stepper>
                                    </div>

                                </div>

                                <!-- Button zum Hinzufügen einer neuen Zuordnung (max. 10) -->
                                <button class="my-4" mat-raised-button color="primary" (click)="addExpenseAssignment()"
                                        [disabled]="expensesAssignments.length >= 10">
                                    <mat-icon>add_circle</mat-icon>
                                    <span class="ml-2">Ziel hinzufügen</span>
                                </button>
                            </div>

                            <div class="mt-4">
                                <button mat-button matStepperPrevious>Zurück</button>
                                <!--                                <button mat-button matStepperNext [disabled]="!mappingFormGroup.valid">Weiter</button>-->
                                <button mat-raised-button matStepperNext [disabled]="this.expensesAssignments.invalid"
                                        color="primary">
                                    Weiter
                                </button>
                            </div>
                        </form>
                    </mat-step>
                } @else if (this.ruleFormGroup.get('targetType')?.value === 'booking') {
                    <mat-step [stepControl]="bookingsAssignments">
                        <form [formGroup]="ruleFormGroup">
                            <ng-template matStepLabel>Zuordnung vervollständigen</ng-template>
                            <p>Bitte wählen Sie die entsprechenden Zuordnungen aus.</p>

                            <div formArrayName="bookingsAssignment" class="mt-4 drop-shadow-xl">
                                <div
                                    *ngFor="let assignment of bookingsAssignments.controls; let i = index; trackBy: trackByFn"
                                    [formGroupName]="i"
                                    class="mb-6 p-4 border rounded drop-shadow-xl">

                                    <mat-vertical-stepper [linear]="true" [selectedIndex]="stepperIndex">

                                        <!-- Step 1: Property -->
                                        <mat-step [stepControl]="assignment.get('property')">
                                            <ng-template
                                                [matTooltip]="assignment.get('property')?.invalid ? 'Wählen Sie die Immobilie aus' : ''"
                                                matStepLabel>
                                                <ng-container *ngIf="assignment.get('property')?.value as property">
                                                    <span>H{{ property?.h_id }} {{ property?.address | formatAddress }}</span>
                                                </ng-container>
                                                <span *ngIf="assignment.get('property')?.invalid">Wählen Sie die Immobilie aus</span>
                                            </ng-template>
                                            <div *ngIf="!assignment.get('property')?.value"
                                                 @zoomIn @zoomOut
                                                 class="flex flex-col space-y-2 w-full">
                                                <app-algolia-autocomplete-new
                                                    (onQuerySuggestionClick)="this.onQueryPropertySuggestionClick2($event,i)"
                                                    (onRefineQuery)="refineQuery(this.searchProperties,$event)"
                                                    (onInputFocused)="startSearch('properties')"
                                                    [hits]="this.hitsProperties"
                                                    formFieldClass="w-full"
                                                    label="Suchen Sie nach der Adresse der Immobilie"
                                                    matOptionStyles="height: 70px; line-height: 20px;"
                                                    placeholder="Suche...">
                                                    <ng-template let-option='option'>
                                                        <div class="flex flex-col">
                                                                <span
                                                                    [innerHTML]="option?._highlightResult?.h_id_text?.value && option?._highlightResult?.h_id_text?.matchLevel === 'full' ? option?._highlightResult?.h_id_text?.value : 'H' + option?._highlightResult?.h_id?.value + ' ' + option?._highlightResult?.address?.streetName?.value + ' ' + option?._highlightResult?.address?.streetNumber?.value"
                                                                    matLine></span>
                                                            <span
                                                                [innerHTML]="option?._highlightResult?.address?.postalCode?.value + ' ' + option?._highlightResult?.address?.locality?.long?.value"
                                                                class="text-xs" matLine></span>
                                                            <mat-divider class="mt-2"></mat-divider>
                                                        </div>
                                                    </ng-template>
                                                </app-algolia-autocomplete-new>
                                            </div>
                                            <div
                                                *ngIf="assignment.get('property')?.value as property"
                                                @zoomIn @zoomOut
                                                class="w-full">
                                                <fuse-card
                                                    class="flex items-center justify-between max-w-80 w-full p-6 filter-info drop-shadow-xl mb-2">
                                                    <div class="flex flex-col">
                                                        <div class="text-2xl font-semibold leading-tight">
                                                            Immobilie <span
                                                            class="font-extrabold text-primary">H{{ property?.h_id }}</span>
                                                        </div>
                                                        <div
                                                            class="text-md leading-tight text-primary">{{ property?.address | formatAddress }}
                                                        </div>
                                                    </div>
                                                    <button
                                                        (click)="resetBookingAssignment(i)"
                                                        color="warn"
                                                        mat-mini-fab
                                                        matTooltip="Zurücksetzen">
                                                        <mat-icon
                                                            [svgIcon]="'mat_outline:close'"
                                                            class="icon-size-5 text-current"></mat-icon>
                                                    </button>
                                                </fuse-card>
                                            </div>
                                            <div *ngIf="assignment.get('property')?.invalid" @zoomIn
                                                 @zoomOut
                                                 class="w-full mt-4">
                                                <!-- Warn -->
                                                <fuse-alert [type]="'warn'">
                                                    <span fuseAlertTitle>Keine Immobilie ausgewählt</span>
                                                    Bitte wählen Sie eine Immobilie aus der Liste aus, bevor Sie
                                                    fortfahren.
                                                </fuse-alert>
                                            </div>
                                            <div class="mt-4">
                                                <button mat-raised-button color="primary"
                                                        [disabled]="assignment.get('property')?.invalid" matStepperNext>
                                                    Weiter
                                                </button>
                                            </div>
                                        </mat-step>

                                        <!-- Step 2: Unit -->
                                        <mat-step [stepControl]="assignment.get('unit')">
                                            <form [formGroup]="assignment">
                                                <ng-template matStepLabel>
                                                    <ng-container *ngIf="stepper.selectedIndex !== 1">
                                                        <ng-container *ngIf="assignment.get('unit')?.value as unit">
                                                            <span>W{{ unit?.w_id }} {{ unit?.label || '' }} {{ unit?.address | formatAddress }}</span>
                                                        </ng-container>
                                                    </ng-container>
                                                    <span
                                                        *ngIf="assignment.get('unit')?.invalid || stepper.selectedIndex === 1">
                                                        Wählen Sie die entsprechende Einheit aus
                                                    </span>
                                                </ng-template>

                                                <div class="w-full my-4">
                                                    <ng-container *ngIf="unitsMap.get(i)?.length > 0; else noUnits">
                                                        <mat-selection-list
                                                            [multiple]="false"
                                                            (selectionChange)="onUnitChange($event, i)"
                                                            color="primary">
                                                            <mat-list-option
                                                                *ngFor="let unit of unitsMap.get(i)"
                                                                [value]="unit"
                                                                [selected]="unit?.id === assignment.get('unit')?.value?.id"
                                                                class="my-2 h-18"
                                                                togglePosition="before">
                                                                <h3 matLine>
                                                                    <div class="flex space-x-1">
                                                                        <span
                                                                            class="font-extrabold text-primary">W{{ unit?.w_id }}</span>
                                                                        <span>{{ unit?.label }}</span>
                                                                    </div>
                                                                </h3>
                                                                @if (unit?.currentManagement) {
                                                                    <div *ngIf="unit?.currentManagement?.landlordsName"
                                                                         class="px-2 w-fit bg-primary text-on-primary rounded"
                                                                         matTooltip="Eigentümer">
                                                                        {{ unit?.currentManagement?.landlordsName }}
                                                                    </div>
                                                                } @else {

                                                                    <div class="flex space-x-1 text-sm" matLine>
                                                                        <div
                                                                            *ngIf="unit?.currentPeriod?.rental?.isRented"
                                                                            class="px-2 bg-primary text-on-primary rounded">
                                                                            vermietet
                                                                        </div>
                                                                        <div
                                                                            *ngIf="unit?.currentPeriod?.rental?.isRented"
                                                                            class="px-2 bg-primary text-on-primary rounded"
                                                                            matTooltip="Saldo">
                                                                            {{ unit?.currentPeriod?.costs?.total | currency:'EUR' }}
                                                                        </div>
                                                                        <div
                                                                            *ngIf="unit?.currentPeriod?.rental?.isRented"
                                                                            class="px-2 bg-primary text-on-primary rounded"
                                                                            matTooltip="Mieter">
                                                                            {{ unit?.currentPeriod?.tenantsName }}
                                                                        </div>
                                                                        <div
                                                                            *ngIf="!unit?.currentPeriod?.rental?.isRented"
                                                                            class="px-2 bg-warn text-on-warn rounded">
                                                                            leerstand
                                                                        </div>
                                                                    </div>
                                                                }

                                                            </mat-list-option>
                                                        </mat-selection-list>
                                                    </ng-container>

                                                    <ng-template #noUnits>
                                                        <fuse-alert [type]="'warn'" class="mt-4">
                                                            <span fuseAlertTitle>Keine Einheiten gefunden</span>
                                                            Für die ausgewählte Immobilie wurden keine Einheiten
                                                            gefunden.
                                                        </fuse-alert>
                                                    </ng-template>
                                                </div>

                                                <div class="mt-4">
                                                    <button mat-button matStepperPrevious>Zurück</button>
                                                    <button
                                                        [disabled]="assignment.get('unit')?.invalid"
                                                        mat-raised-button color="primary"
                                                        matStepperNext
                                                        (click)="onUnitSelection(i,assignment.get('unit')?.value)">
                                                        Weiter
                                                    </button>
                                                </div>
                                            </form>
                                        </mat-step>

                                        <!-- Step 3: Period -->
                                        <mat-step [stepControl]="assignment.get('period')">
                                            <form [formGroup]="assignment">
                                                <ng-template matStepLabel>
                                                    <ng-container *ngIf="stepper.selectedIndex !== 2">
                                                        <ng-container *ngIf="assignment.get('period')?.value as period">
                                                            @if (assignment.get('unit')?.value?.currentPeriod) {
                                                                <span>
                                                        Vermietung von {{ period?.rental?.startDate | toDate | date:'shortDate' }}
                                                                    <span
                                                                        *ngIf="period?.tenantsName"> / {{ period?.tenantsName }}</span>
                                                        / Warmmiete {{ period?.costs?.total | currency:'EUR' }}
                                                    </span>
                                                            } @else {
                                                                <span>
                                                            Verwaltung von {{ period?.startDate | toDate | date:'shortDate' }}
                                                                    <span
                                                                        *ngIf="period?.landlordsName"> / {{ period?.landlordsName }}</span>
                                                            / Gesamt {{ period?.costs?.total | currency:'EUR' }}
                                                        </span>
                                                            }
                                                        </ng-container>
                                                    </ng-container>
                                                    <span
                                                        *ngIf="assignment.get('period')?.invalid || stepper.selectedIndex === 2">
                                                    Wählen Sie den zugehörigen Vermietungszeitraum aus
                                                </span>
                                                </ng-template>

                                                <div class="w-full my-4">
                                                    @if (assignment?.get('unit')?.value?.currentPeriod) {
                                                        <ng-container
                                                            *ngIf="periodsMap.get(i)?.length > 0; else noPeriods">
                                                            <mat-selection-list
                                                                (selectionChange)="onPeriodChange($event, i)"
                                                                color="primary"
                                                                [multiple]="false">
                                                                <mat-list-option
                                                                    *ngFor="let period of periodsMap.get(i)"
                                                                    [value]="period"
                                                                    [selected]="period?.id === assignment.get('period')?.value?.id"
                                                                    class="my-2 h-fit py-4 px-3 rounded-md border border-gray-200 hover:shadow-md duration-200"
                                                                    togglePosition="before">

                                                                    <ng-container
                                                                        *ngIf="assignment.get('unit')?.value as unit">
                                                                        <h3 matLine class="font-bold mb-1"
                                                                            [ngClass]="unit?.currentPeriod?.id === period?.id ? 'text-primary' : 'text-black'">
                                                                            {{ unit?.currentPeriod?.id === period?.id ? 'Aktive Vermietung' : 'Beendete Vermietung' }}
                                                                        </h3>
                                                                    </ng-container>

                                                                    <div class="flex flex-row flex-wrap gap-2" matLine>
                                                            <span
                                                                class="px-2 py-0.5 bg-primary text-on-primary text-sm rounded">
                                                            {{ period?.rental?.startDate | toDate | date }}
                                                            </span>
                                                                        <span *ngIf="period?.costs?.total"
                                                                              class="px-2 py-0.5 bg-primary text-on-primary text-sm rounded">
                                                            {{ period?.costs?.total | currency:'EUR' }}
                                                            </span>
                                                                        <span *ngIf="period?.tenantsName"
                                                                              class="px-2 py-0.5 bg-primary text-on-primary text-sm rounded">
                                                            {{ period?.tenantsName }}
                                                            </span>
                                                                    </div>
                                                                </mat-list-option>

                                                            </mat-selection-list>
                                                        </ng-container>

                                                        <ng-template #noPeriods>
                                                            <fuse-alert [type]="'warn'" class="mt-4">
                                                                <span fuseAlertTitle>Keine Vermietungen gefunden</span>
                                                                Für die ausgewählte Einheit wurden keine Vermietungen
                                                                gefunden.
                                                            </fuse-alert>
                                                        </ng-template>
                                                    } @else {
                                                        <ng-container
                                                            *ngIf="managementsMap.get(i)?.length > 0; else noManagements">
                                                            <mat-selection-list
                                                                (selectionChange)="onPeriodChange($event, i)"
                                                                color="primary"
                                                                [multiple]="false">
                                                                <mat-list-option
                                                                    *ngFor="let management of managementsMap.get(i)"
                                                                    [value]="management"
                                                                    [selected]="management?.id === assignment.get('period')?.value?.id"
                                                                    class="my-2 h-fit py-4 px-3 rounded-md border border-gray-200 hover:shadow-md duration-200"
                                                                    togglePosition="before">

                                                                    <ng-container
                                                                        *ngIf="assignment.get('unit')?.value as unit">
                                                                        <h3 matLine class="font-bold mb-1"
                                                                            [ngClass]="unit?.currentManagement.id === management?.id ? 'text-primary' : 'text-black'">
                                                                            {{ unit?.currentManagement.id === management?.id ? 'Aktive Verwaltung' : 'Beendete Verwaltung' }}
                                                                        </h3>
                                                                    </ng-container>

                                                                    <div class="flex flex-row flex-wrap gap-2" matLine>
                                                            <span
                                                                class="px-2 py-0.5 bg-primary text-on-primary text-sm rounded">
                                                            {{ management?.startDate | toDate | date }}
                                                            </span>
                                                                        <span *ngIf="management?.costs?.total"
                                                                              class="px-2 py-0.5 bg-primary text-on-primary text-sm rounded">
                                                            {{ management?.costs?.total | currency:'EUR' }}
                                                            </span>
                                                                        <span *ngIf="management?.landlordsName"
                                                                              class="px-2 py-0.5 bg-primary text-on-primary text-sm rounded">
                                                            {{ management?.landlordsName }}
                                                            </span>
                                                                    </div>
                                                                </mat-list-option>

                                                            </mat-selection-list>
                                                        </ng-container>

                                                        <ng-template #noManagements>
                                                            <fuse-alert [type]="'warn'" class="mt-4">
                                                                <span fuseAlertTitle>Keine Verwaltung gefunden</span>
                                                                Für die ausgewählte Einheit wurden keine Verwaltung
                                                                gefunden.
                                                            </fuse-alert>
                                                        </ng-template>
                                                    }
                                                </div>

                                                <div class="mt-4">
                                                    <button mat-button matStepperPrevious>Zurück</button>
                                                </div>
                                            </form>
                                        </mat-step>

                                    </mat-vertical-stepper>

                                    <!-- Remove assignment -->
                                    <div class="flex justify-end mt-2">
                                        <button mat-icon-button color="warn" (click)="removeBookingAssignment(i)"
                                                matTooltip="Zuordnung entfernen">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                </div>

                                <!-- Add assignment -->
                                <div class="my-6">
                                    <button mat-stroked-button color="primary" (click)="addBookingAssignment()">
                                        <mat-icon>add</mat-icon>
                                        Neue Zuordnung
                                    </button>
                                </div>
                            </div>

                            <div class="mt-6">
                                <button mat-button matStepperPrevious>Zurück</button>
                                <button mat-raised-button matStepperNext [disabled]="this.bookingsAssignments.invalid"
                                        color="primary">
                                    Weiter
                                </button>
                            </div>
                        </form>
                    </mat-step>
                }

                <mat-step *ngIf="this.ruleFormGroup.get('targetType')?.value === 'booking'">
                    <ng-template matStepLabel>Automatisch verbuchen mit Nahaus KI</ng-template>
                    <form [formGroup]="ruleFormGroup">
                        <div class="flex flex-col space-y-2 py-2">
                            <fuse-alert [type]="'primary'" [showIcon]="false">
                                Erlauben Sie der Nahaus KI, die Transaktion automatisch zu verbuchen, wenn passende
                                offene Sollstellungen anhand dieser hinterlegten Regel gefunden werden.
                            </fuse-alert>
                            <div class="flex mt-2 items-center">
                                <mat-slide-toggle
                                    color="primary"
                                    formControlName="autoSoll">
                                </mat-slide-toggle>
                            </div>
                            <mat-form-field
                                *ngIf="ruleFormGroup.get('autoSoll').value"
                                @zoomIn @zoomOut
                                class="w-full sm:w-1/2 md:w-1/3">
                                <mat-label>Mindest-Konfidenz erforderlich</mat-label>
                                <mat-select formControlName="minimumScoreRequired"
                                            [class]="'selected-' + ruleFormGroup.get('minimumScoreRequired').value">
                                    <mat-option *ngFor="let option of scoreOptions"
                                                [value]="option.value"
                                                [ngClass]="option.className">
                                        {{ option.viewValue }}
                                    </mat-option>
                                </mat-select>
                                <mat-hint>Nur Vorschläge mit dieser Konfidenz/Score werden automatisch verbucht.
                                </mat-hint>
                            </mat-form-field>
                        </div>
                    </form>
                    <div class="mt-4">
                        <button mat-button matStepperPrevious>Zurück</button>
                        <button mat-raised-button
                                matStepperNext
                                color="primary">
                            Weiter
                        </button>
                    </div>
                </mat-step>

                <!-- Step 6: Review and Save -->
                <mat-step>
                    <ng-template matStepLabel>Überprüfung</ng-template>
                    <ng-container *ngIf="true">
                        <div class="flex flex-col mt-6">
                            <!-- STEP 1: Bankkonto -->
                            <div class="flex">
                                <!-- Bullet + Connector -->
                                <div class="flex flex-col items-center">
                                    <div
                                        class="h-8 w-8 rounded-full flex items-center justify-center bg-primary-600 text-white">
                                        1
                                    </div>
                                    <div class="flex-1 w-px bg-primary-100" *ngIf="true"></div>
                                </div>
                                <!-- Card -->
                                <!-- Accent -->
                                <fuse-alert class="ml-4 flex-1 drop-shadow-xl"
                                            [type]="'accent'"
                                            [appearance]="'soft'">
                                    <mat-icon class="icon-size-5"
                                              fuseAlertIcon
                                              [svgIcon]="'mat_outline:account_balance'"></mat-icon>
                                    <span fuseAlertTitle>Bankkonto</span>
                                    <p>
                                        @if (ruleFormGroup.get('forAllBankAccounts')?.value) {
                                            <span>Alle verknüpften Konten</span>
                                        } @else if (selectedBankAccountsFormArray.length > 0) {
                                            <span
                                                *ngFor="let account of selectedBankAccountsFormArray.controls; let i = index">
                                            {{ account.value.bank }} <span
                                                class="text-md text-primary">{{ account.value.IBAN }}</span><span
                                                *ngIf="i < selectedBankAccountsFormArray.length - 1">, </span>
                                </span>
                                        } @else {
                                            <span>Nicht angegeben</span>
                                        }
                                    </p>
                                </fuse-alert>
                            </div>

                            <!-- STEP 2: IBAN Filter -->
                            <div class="flex mt-6">
                                <div class="flex flex-col items-center">
                                    <div
                                        class="h-8 w-8 rounded-full flex items-center justify-center bg-primary-600 text-white">
                                        2
                                    </div>
                                    <div class="flex-1 w-px bg-primary-100" *ngIf="true"></div>
                                </div>
                                <!-- Accent -->
                                <fuse-alert class="ml-4 flex-1 drop-shadow-xl"
                                            [type]="'accent'"
                                            [appearance]="'soft'">
                                    <mat-icon class="icon-size-5"
                                              fuseAlertIcon
                                              [svgIcon]="'mat_outline:credit_card'"></mat-icon>

                                    <span fuseAlertTitle>
                                        {{ ruleFormGroup.get('requireTransactionIban')?.value ? 'IBAN-Pflicht aktiv' : 'Keine Pflicht-IBAN' }}
                                    </span>

                                    <div class="mt-1 text-sm">
                                        <ng-container
                                            *ngIf="ruleFormGroup.get('requireTransactionIban')?.value; else ibanOptionalInfo">
                                            {{ ruleFormGroup.get('transactionIban')?.value }}
                                        </ng-container>

                                        <ng-template #ibanOptionalInfo>
                                            Die Regel wird anhand der definierten Bedingungen geprüft.
                                        </ng-template>
                                    </div>
                                </fuse-alert>
                            </div>

                            <!-- STEP 3: Bedingungen -->
                            <div class="flex mt-6">
                                <div class="flex flex-col items-center">
                                    <div
                                        class="h-8 w-8 rounded-full flex items-center justify-center bg-primary-600 text-white">
                                        3
                                    </div>
                                    <div class="flex-1 w-px bg-primary-100" *ngIf="true"></div>
                                </div>
                                <!-- Accent -->
                                <fuse-alert class="ml-4 flex-1 drop-shadow-xl"
                                            [type]="'accent'"
                                            [appearance]="'soft'">
                                    <mat-icon class="icon-size-5"
                                              fuseAlertIcon
                                              [svgIcon]="'mat_outline:rule'"></mat-icon>
                                    <span fuseAlertTitle>Bedingungen</span>
                                    <div class="flex w-full">
                                        <ng-container *ngIf="this.conditions; else noCond">
                                            <mat-chip-set aria-label="Filterbedingungen">
                                                @for (condition of conditions.controls; track condition) {
                                                    <mat-chip>
                                                        {{ condition.value?.field | transactionRuleReferenceText }} {{ condition.value?.operator | transactionRuleOperatorText }} {{ condition.value?.value }}
                                                    </mat-chip>
                                                }

                                            </mat-chip-set>
                                        </ng-container>
                                        <ng-template #noCond>
                                            <span>Keine zusätzlichen Bedingungen</span>
                                        </ng-template>
                                    </div>
                                </fuse-alert>
                            </div>

                            <!-- STEP 4: Zuordnungstyp -->
                            <div class="flex mt-6">
                                <div class="flex flex-col items-center">
                                    <div
                                        class="h-8 w-8 rounded-full flex items-center justify-center bg-primary-600 text-white">
                                        4
                                    </div>
                                    <div class="flex-1 w-px bg-primary-100" *ngIf="true"></div>
                                </div>
                                <!-- Accent -->
                                <fuse-alert class="ml-4 flex-1 drop-shadow-xl"
                                            [type]="'accent'"
                                            [appearance]="'soft'">
                                    <mat-icon class="icon-size-5"
                                              fuseAlertIcon
                                              [svgIcon]="'mat_outline:category'"></mat-icon>
                                    <span fuseAlertTitle>Zuordnungstyp:
                                        {{ (this.ruleFormGroup.get('targetType')?.value === 'expense' ? 'Ausgabe' : 'Sollstellung') }}</span>
                                </fuse-alert>
                            </div>

                            <!-- STEP 5: Zuordnung -->
                            <div class="flex mt-6">
                                <div class="flex flex-col items-center">
                                    <div
                                        class="h-8 w-8 rounded-full flex items-center justify-center bg-primary-600 text-white">
                                        5
                                    </div>
                                </div>
                                <!-- Accent -->
                                <fuse-alert class="ml-4 flex-1 drop-shadow-xl"
                                            [type]="'accent'"
                                            [appearance]="'soft'">
                                    <mat-icon class="icon-size-5"
                                              fuseAlertIcon
                                              [svgIcon]="'mat_outline:link'"></mat-icon>
                                    <span fuseAlertTitle>Zuordnung</span>
                                    @if (this.ruleFormGroup.get('targetType')?.value === 'expense') {
                                        <table class="w-full text-sm">
                                            @for (expenseAssigment of expensesAssignments?.controls; track expenseAssigment) {
                                                <tr class="border-b border-gray-200">
                                                    <td class="py-2 font-medium">Immobilie</td>
                                                    <td class="py-2">{{ (expenseAssigment.value?.property?.address | formatAddress) || '–' }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="py-2 font-medium">Buchungskonto</td>
                                                    <td class="py-2">
                                                        [{{ expenseAssigment.value?.nahausBookingsAccount?.refID }}
                                                        ] {{ (expenseAssigment.value?.nahausBookingsAccount?.label) || '–' }}
                                                    </td>
                                                </tr>
                                            }
                                        </table>
                                    } @else {
                                        <table class="w-full text-sm">
                                            @for (bookingAssignment of bookingsAssignments?.controls; track bookingAssignment; let
                                                last = $last) {
                                                <tr>
                                                    <td class="py-2 font-medium">Immobilie</td>
                                                    <td class="py-2">{{ bookingAssignment.value?.property?.address | formatAddress }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="py-2 font-medium">Einheit</td>
                                                    <td class="py-2">{{ bookingAssignment.value?.unit?.label }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="py-2 font-medium">Vermietung</td>
                                                    <td class="p-2">
                                                        von
                                                        {{ bookingAssignment.value?.period?.rental?.startDate | toDate | date:'shortDate' }}
                                                        <span *ngIf="bookingAssignment.value?.period?.tenantsName">
                                                        / {{ bookingAssignment.value.period.tenantsName }}
                                                    </span>
                                                        / Warmmiete
                                                        {{ bookingAssignment.value?.period?.costs?.total | currency:'EUR' }}
                                                    </td>
                                                </tr>
                                                @if (!last) {
                                                    <tr>
                                                        <td colspan="2" class="p-0">
                                                            <mat-divider class="w-full my-2"></mat-divider>
                                                        </td>
                                                    </tr>
                                                }
                                            }
                                        </table>
                                    }

                                </fuse-alert>
                            </div>
                        </div>
                    </ng-container>
                    <div class="my-4">
                        <button mat-button matStepperPrevious>Zurück</button>
                    </div>
                </mat-step>

            </mat-vertical-stepper>

        </div>
    </div>

    <!-- Actions -->
    <div
        class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10 sticky bottom-0">

        <!-- Cancel -->
        <button
            [matDialogClose]="'cancelled'"
            mat-stroked-button>
            Abbrechen
        </button>

        <!-- Confirm -->
        <button
            (click)="save()"
            color="primary"
            [disabled]="this.ruleFormGroup?.invalid || this.saving"
            mat-flat-button>
            <span *ngIf="!this.saving">Speichern</span>
            <mat-progress-spinner *ngIf="this.saving" [diameter]="36"
                                  color="primary"
                                  mode="indeterminate"></mat-progress-spinner>
        </button>

    </div>

</div>
